import { Switch, TextField } from '@material-ui/core';
import React, { useState } from 'react';

import { Col, Cols, Row, Rows, Text } from '~/src/dash/publicaUI';
import { publicaColors } from '~/src/dash/utils/colors';
import { IProps } from '~/src/dash/views/ias-publisher/IASReportBuilder/Report/common/types';

// import { hasRoleSuperUser } from '~/src/dash/utils/roles';

export const OverviewRow = (props: IProps) => {
  // const {user} = useBaseStore();
  const [superUserToggle, setSuperUserToggle] = useState<boolean>(false);
  return (
    <Cols wrap responsive verticalPadding>
      <Col>
        <Rows>
          <Row noPadding>
            <Cols wrap style={{ alignItems: 'center' }}>
              <Col style={{ minWidth: '85px' }}>
                <Text small bold>
                  {' '}
                  Report Name{' '}
                </Text>
              </Col>
              <Col hugeHorizontalPadding>
                <TextField
                  name='Report name'
                  placeholder={'Report Name'}
                  value={props.reportName}
                  onChange={props.handleChangeReportName}
                  style={{
                    width: '400px',
                    border: `1px solid ${publicaColors.lightGray}`,
                    borderRadius: '5px',
                    paddingLeft: '4px',
                    fontSize: '12px',
                  }}
                />
              </Col>
            </Cols>
          </Row>
        </Rows>
      </Col>
      {/* Super user toggle and info */}
      {
        // hasRoleSuperUser(user.user) &&
        <Col>
          <Cols style={{ alignItems: 'center' }}>
            <Col>
              <Text small bold>
                {' '}
                Super User *{' '}
              </Text>
            </Col>
            <Col>
              <Switch
                name='EnableSuperUser'
                value={superUserToggle}
                onChange={() => setSuperUserToggle(!superUserToggle)}
              />
            </Col>
          </Cols>
        </Col>
      }
      {superUserToggle && (
        <Col
          style={{
            height: 'fit-content',
            background: `${publicaColors.veryLightGray}`,
            borderRadius: '5px',
            marginLeft: '8px',
            marginBottom: '18px',
          }}
        >
          <Rows>
            <Row smallPadding>
              <Cols style={{ justifyContent: 'space-between' }}>
                <Col style={{ minWidth: '100px' }}>
                  <Text extraSmall bold>
                    {' '}
                    Created by{' '}
                  </Text>
                </Col>
                <Col smallHorizontalPadding>
                  <Text extraSmall> {props.superUserInfo.createdBy} </Text>
                </Col>
                <Col smallHorizontalPadding>
                  <Text extraSmall> {props.superUserInfo.createdOn} </Text>
                </Col>
              </Cols>
            </Row>
            <Row smallPadding>
              <Cols style={{ justifyContent: 'space-between' }}>
                <Col>
                  <Text extraSmall bold>
                    {' '}
                    Last Modified On
                  </Text>
                </Col>
                <Col smallHorizontalPadding>
                  <Text extraSmall> {props.superUserInfo.lastModified} </Text>
                </Col>
              </Cols>
            </Row>
            <Row smallPadding>
              <Cols style={{ justifyContent: 'space-between' }}>
                <Col>
                  <Text extraSmall bold>
                    {' '}
                    Last Ran{' '}
                  </Text>
                </Col>
                <Col smallHorizontalPadding>
                  <Text extraSmall> {props.superUserInfo.lastRun} </Text>
                </Col>
              </Cols>
            </Row>
          </Rows>
        </Col>
      )}
    </Cols>
  );
};
